import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
class CustomTooltip extends React.Component {
  render() {
    return (
      <>
        <Tooltip
          arrow
          className={this.props?.className}
          title={this.props.title}
          id={this.props.id}
          placement={this.props.placement}
          open={this.props.open && this.props.open}
          classes={{ popper: "custom-tooltip" }}
        >
          {this.props.children}
        </Tooltip>
      </>
    );
  }
}

export default CustomTooltip;
